import { apiPost } from '../api'

export const issue_catch_up_day = data => {
  return apiPost({
    endpoint: 'attendance/issue_catch_up_day',
    data: data
  })
}
